<sb-dialog-header>
  <h1 sb-dialog-title>
    {{ 'What do you want to create a template for?' | translate }}
  </h1>
</sb-dialog-header>

<sb-dialog-content>
  <sb-radio-card-group [formControl]="templateTypeControl">
    <fieldset>
      <sb-radio-card [value]="TemplateCategory.HIRE">
        {{ 'Employment contract' | translate }}
        <div description>{{ 'Create a new employment contract for a new employee.' | translate }}</div>
      </sb-radio-card>
      <sb-radio-card [value]="TemplateCategory.EXTENSION">
        {{ 'Contract extension' | translate }}
        <div description>{{ 'For extending or renewing an existing employment contract.' | translate }}</div>
      </sb-radio-card>
    </fieldset>
  </sb-radio-card-group>

  <a [href]="'digitally-sign-contracts' | knowledgeBaseArticleLink" target="_blank">
    {{ 'Learn more about templates' | translate }}
  </a>
</sb-dialog-content>

<sb-dialog-footer>
  <sb-dialog-footer-actions [align]="'end'">
    <button sb-button [color]="'primary'" [disabled]="templateTypeControl.invalid" (click)="submit()">
      {{ 'Continue' | translate }}
    </button>
  </sb-dialog-footer-actions>
</sb-dialog-footer>
